import { getAutoPause } from '../../../../store/general/selectors';
import { getState } from '../../../../store';
import { Pause } from '../../../../types/pause-constants';
import { PlayerManager } from '../playerManager';
import { EPlayerControllerMode, PlayerController } from '../playerController';

export abstract class PlayCaptionBaseHandler {

  protected async handleTargetIndexChange(index: number, disablePlayTranslate: boolean) {
    const pause = getAutoPause(getState());
    if (pause === Pause.NoPauseValue) return;
    PlayerManager.getInstance().pausePlay();
    if (pause !== Pause.FullStopValue) {
      PlayerController.getInstance().startWaitTimer(pause * 1000);
    }
  }

  protected abstract getHandlerPlayMode(): EPlayerControllerMode;
}
